import {ICancelablePromise} from '@src/@interfaces/classes/CancelablePromise/ICancelablePromise';
import {TPromiseExecutor} from '@src/@types/promise';

export default class CancelablePromise<T> extends Promise<T> implements ICancelablePromise<T> {
    constructor(
        executor: TPromiseExecutor<T>,
        protected onCancel: () => void,
    ) {
        super(executor);
    }

    cancel() {
        return this.onCancel();
    }
}
